import { useMemo } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { checkinEntryOptions } from "../../../../constants/directiveEntryFormSteps/checkinEntry/checkinEntryOptions.constant";
import { CheckinEntryValidationSchema } from "../../../../schemas/maintenanceForwardingDirectiveSteps.schema";
import { MaintenanceForwardingCheckinEntryKlass } from "../../../../types/forwardings/checkinEntries/checkinEntry.type";
import { MaintenanceForwardingsDirectiveFormStepProps } from "../../../../types/maintenanceforwardingsDirectiveFormStep.type";
import { MaintenanceForwardingsDirectiveFromSteps } from "../../../../types/maintenanceForwardingsShowDirectiveDetails.type";
import CreateForwardingDirectiveEntryFormStepCompleted from "../../../CreateForwardingDirectiveEntryFormStepCompleted";

const CheckinEntryFormStepCompleted = ({
  stepIndex,
}: MaintenanceForwardingsDirectiveFormStepProps<MaintenanceForwardingsDirectiveFromSteps.CheckinEntry>) => {
  const {
    control,
  } = useFormContext<CheckinEntryValidationSchema>();

  const {
    checkin_entry_type: watchCheckinEntryType,
  } = useWatch({
    control,
  });

  const EntryOptionComponent = useMemo(() => {
    if (watchCheckinEntryType) {
      const checkinEntryOption = checkinEntryOptions[watchCheckinEntryType as MaintenanceForwardingCheckinEntryKlass];

      return checkinEntryOption.components.completed;
    }

    return null;
  }, [watchCheckinEntryType]);

  return (
    <CreateForwardingDirectiveEntryFormStepCompleted
      stepIndex={stepIndex}
      title="Método de check-in"
      body={(
        <div>
          {EntryOptionComponent && (
            <EntryOptionComponent />
          )}
        </div>
      )}
    />
  )
}

export default CheckinEntryFormStepCompleted;
